
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateScoreGradeForm from '@/services/QA/scoreGrade/forms/CreateScoreGradeForm';
import { ScoreGradeRepositoryInterface } from '@/services/QC-V2/score-grade/interfaces';

@Component({
  inject: [
    'scoreGradeRepositoryV2',
  ],
})
export default class CreateScoreGrade extends Vue {
  private readonly scoreGradeRepositoryV2!: ScoreGradeRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<CreateScoreGradeForm> = new WPXFormValue(CreateScoreGradeForm);

  public created(): void {
    this.loading = false;
  }

  private async createScoreGrade(): Promise<void> {
    try {
      await this.scoreGradeRepositoryV2.createScoreGrade({
        label: this.form.data.label,
        value: Number(this.form.data.value),
      });

      this.$successDialog.show(`Score Grade '${this.form.data.label}' has been created`);
      await this.$router.push({ name: 'scores' });
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
